import * as lib from './lib';
import * as config from './config';

export const rwPassengerDataValidation = { lib, config };
export * as rwPassengerDataValidationTypes from './types';
